// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__8KLRV","addWidgetButton":"Header_addWidgetButton__6m0YD","dashboardTabs":"Header_dashboardTabs__Hcbh4","active":"Header_active__1Skiy"};